module.exports = __webpack_public_path__ + "img/homelunbotopnew2.57a1cfad.jpg";